import {useApi} from "../Api";
import {Sell} from "../types/constants";

export const useConstantsRepository = () => {
    const {GET} = useApi();

    const PATH = "/pricing/constants";

    function getCurrencies(): Promise<string[]> {
        return GET(`${PATH}/currency-list`);
    }

    function getChargingWays(): Promise<string[]> {
        return GET(`${PATH}/charging-ways`);
    }

    function getTypes(): Promise<string[]> {
        return GET(`${PATH}/ancillary-types`);
    }

    function getSubtypes(type: string): Promise<string[]> {
        return GET(`${PATH}/ancillary-subtypes?ancillaryType=${type}`);
    }

    function getSell(): Promise<Sell[]> {
        return GET(`${PATH}/sell-types`);
    }

    function getTpUnitsEnum(): Promise<string[]> {
        return GET(`${PATH}/tp-units`);
    }

    return {
        getCurrencies,
        getChargingWays,
        getTypes,
        getSell,
        getSubtypes,
        getTpUnitsEnum
    };
};